module.exports = function() {
  return new Worker(__webpack_public_path__ + "a510936f6bdb33fc3a1c.worker.js");
};